<script setup lang="ts">
import type { AccordionTriggerProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { MinusIcon, PlusIcon } from '@heroicons/vue/24/outline'
import { reactiveOmit } from '@vueuse/core'
import { AccordionHeader, AccordionTrigger } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <AccordionHeader class="flex">
    <AccordionTrigger
      v-bind="delegatedProps"
      :class="
        cn(
          'group flex flex-1 w-full items-center justify-between gap-2 p-5 cursor-pointer text-left text-primal',
          props.class,
        )
      "
    >
      <slot />
      <slot name="icon">
        <PlusIcon class="size-4 shrink-0 text-primal group-data-[state=open]:hidden" />
        <MinusIcon class="size-4 shrink-0 text-primal group-data-[state=closed]:hidden" />
      </slot>
    </AccordionTrigger>
  </AccordionHeader>
</template>
